import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class StaffVacationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: this.props.staff_id,
      date_start: '',
      date_finish: '',
      vacation_right: '',
      vacation_end: '',
      staff_vacations: [],
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_vacations)) {
      this.setState({
        staff_vacations: newProps.staff_vacations,
        loaded: 1
      });
    }
  }
  
  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     date_start: this.state.date_start,
  //     date_finish: this.state.date_finish,
  //     only_active: this.state.only_active,
  //     vacation_right: this.state.vacation_right,
  //     vacation_end: this.state.vacation_end,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.setState({ staff_vacations: responseJson.data });
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  
  
  // // Fetch ativando um item
  // ativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar essas ferias?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/ferias/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_vacations: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch deletando um item
  // desativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essas ferias?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/ferias/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_vacations: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/ferias/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_vacations: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/ferias/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_vacations: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tituloFerias}</h3>
  <hr/>
  {(this.state.staff_vacations === null || typeof this.state.staff_vacations === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.nenhumaFeriasCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.DataInicial}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.DataFinal}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.DireitoAFerias}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.VencimentoDeFerias}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.Status}</th>
          {/* <th className="text-center">Ações</th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_vacations).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_vacations[k].date_start_str}</td>
              <td className="text-center">{self.state.staff_vacations[k].date_finish_str}</td>
              <td className="text-center">{self.state.staff_vacations[k].vacation_right_str}</td>
              <td className="text-center">{self.state.staff_vacations[k].vacation_end_str}</td>
              <td className="text-center">{(self.state.staff_vacations[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.Arquivado}</span>}</td>
              {/* <td className="text-center">
                {(self.state.staff_vacations[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_vacations[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_vacations[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Cadastrar férias</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data inicial:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Data final:</label>
        <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Direito à férias:</label>
        <InputMask value={this.state.vacation_right}  maskChar={null} name="vacation_right" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'vacation_right')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Vencimento de férias:</label>
        <InputMask value={this.state.vacation_end}  maskChar={null} name="vacation_end" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'vacation_end')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar férias</button>
  </form> */}
</div>
    );
  }
}

export default StaffVacationsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffVacationsTab.js